<template>
  <div class="container">
    <h2>Mot de passe oublié</h2>
    <el-form :inline="true" >
      <el-form-item label="Email" >
        <el-input type="email" v-model="email" />
      </el-form-item>
      <el-button type="primary" @click="forgotEmail" >Valider</el-button>
    </el-form>
    <router-link to="/login" >Retour</router-link>
  </div>
</template>

<script>
import {api} from 'macarons'

export default {
  data () {
    return {
      email: null
    }
  },
  methods: {
    forgotEmail () {
      if (!this.email || !this.email.match(/^.+@.+\..+$/)) {
        this.$notify.error({
          title: 'Erreur',
          message: 'Ceci n\'est pas un email valide'
        })
      } else {
        api.get('security/forgot-password?email=' + this.email).then(() => {
          this.$notify.success({
            title: 'Email envoyé',
            message: 'Un email permettant de créer un nouveau mot de passe vous a été envoyé. Si vous ne le recevez pas, veuillez vérifier le dossier spam de votre boîte mail, et que vous n\'avez pas effectué d\'erreur en renseignant votre email'
          })
        }).catch(() => {
          this.$notify.error({
            title: 'Erreur',
            message: 'Une erreur est survenue durant l\'envoi de l\'email permettant de réinitialiser votre mot de passe'
          })
        })
      }
    }
  }
}
</script>

<style scoped>
.container {
  margin-left: auto;
  margin-right: auto;
  margin-top: 20vh;
  width: 95vW;
  max-width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/security/components/ForgotPassword.vue